import { combineReducers } from 'redux';
import intentionAddingReducer from './intentionAddingReducer';
import intentionsGettingReducer from './intentionsGettingReducer';

export default combineReducers({
  intentionAddingReducer,
  intentionsGettingReducer
});
